import React, { useEffect, useState } from "react";
import { apiFetch } from "../api";
import EditUserModal from "./EditUserModal";

// Public-user "Edit Your Profile". Loads the User profile linked to the
// caller (via the publicUser ref on the User), then reuses EditUserModal so
// the form layout matches the bureau-side profile editor exactly. Save goes
// through the public-auth endpoint instead of the bureau-protected /profiles/:id.
function EditUserProfileModal({ isOpen, onClose, onSaved }) {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!isOpen) {
      setProfile(null);
      setError("");
      return;
    }
    let cancelled = false;
    setLoading(true);
    setError("");
    apiFetch("/public/auth/my-profile")
      .then((data) => {
        if (cancelled) return;
        setProfile(data);
      })
      .catch((err) => {
        if (cancelled) return;
        console.error("Failed to load my profile:", err);
        setError(err.message || "Failed to load your profile");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [isOpen]);

  if (!isOpen) return null;

  if (loading || error || !profile) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
        <div className="w-full max-w-md rounded-xl bg-[var(--color-surface)] p-6 shadow-lg">
          <div className="flex items-start justify-between mb-3">
            <h3 className="text-lg font-semibold text-[var(--color-text-strong)]">
              Edit Your Profile
            </h3>
            <button
              onClick={onClose}
              className="text-sm font-semibold text-[var(--color-text)]"
            >
              Close
            </button>
          </div>
          {loading && (
            <div className="text-sm text-[var(--color-text-muted)]">
              Loading your profile…
            </div>
          )}
          {error && (
            <div className="rounded-lg border border-[var(--color-danger-border)] bg-[var(--color-danger-bg)] px-3 py-2 text-sm text-[var(--color-danger-text)]">
              {error}
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <EditUserModal
      isOpen={isOpen}
      initialData={profile}
      onClose={onClose}
      onSaved={onSaved}
      endpointPath="/public/auth/my-profile"
      title="Edit Your Profile"
    />
  );
}

export default EditUserProfileModal;
